/**
 * WMS Quality Check Types
 * Shared between backend-wms and mobile-app
 *
 * DRY Compliance: Single source for all quality check enums
 */

/**
 * Result of a quality check inspection
 */
export enum QualityCheckResult {
  PASS = 'PASS',
  FAIL = 'FAIL',
  CONDITIONAL = 'CONDITIONAL',
}

/**
 * Status of a quality check process
 */
export enum QualityCheckStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  PASSED = 'PASSED',
  FAILED = 'FAILED',
  ON_HOLD = 'ON_HOLD',
}

/**
 * Result labels for UI display
 */
export const QualityCheckResultLabels: Record<QualityCheckResult, string> = {
  [QualityCheckResult.PASS]: 'Pass',
  [QualityCheckResult.FAIL]: 'Fail',
  [QualityCheckResult.CONDITIONAL]: 'Conditional',
};

export const QualityCheckStatusLabels: Record<QualityCheckStatus, string> = {
  [QualityCheckStatus.PENDING]: 'Pending',
  [QualityCheckStatus.IN_PROGRESS]: 'In Progress',
  [QualityCheckStatus.PASSED]: 'Passed',
  [QualityCheckStatus.FAILED]: 'Failed',
  [QualityCheckStatus.ON_HOLD]: 'On Hold',
};

/**
 * Color schemes for status/result badges (Chakra UI v3 compatible)
 */
export const QualityCheckResultColors: Record<QualityCheckResult, string> = {
  [QualityCheckResult.PASS]: 'green',
  [QualityCheckResult.FAIL]: 'red',
  [QualityCheckResult.CONDITIONAL]: 'yellow',
};

export const QualityCheckStatusColors: Record<QualityCheckStatus, string> = {
  [QualityCheckStatus.PENDING]: 'gray',
  [QualityCheckStatus.IN_PROGRESS]: 'blue',
  [QualityCheckStatus.PASSED]: 'green',
  [QualityCheckStatus.FAILED]: 'red',
  [QualityCheckStatus.ON_HOLD]: 'orange',
};
